import { useRef, type ReactNode } from 'react';
import { toast } from 'sonner';

interface CodeBlockProps {
  children?: ReactNode;
}

export default function CodeBlock({ children, ...props }: CodeBlockProps) {
  const preRef = useRef<HTMLPreElement>(null);

  const handleCopy = async () => {
    const text = preRef.current?.textContent ?? '';
    try {
      await navigator.clipboard.writeText(text);
      toast.success('Code copied');
    } catch {
      toast.error('Failed to copy');
    }
  };

  return (
    <div className="relative group">
      <pre ref={preRef} {...props}>
        {children}
      </pre>
      <button
        onClick={handleCopy}
        className="absolute top-2 right-2 text-xs px-2 py-0.5 font-mono opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer"
        style={{
          color: 'var(--color-accent)',
          border: '1px solid var(--color-border)',
          backgroundColor: 'var(--color-background)',
        }}
      >
        [ COPY ]
      </button>
    </div>
  );
}
